module.exports = __webpack_public_path__ + "static/media/BrixSans-ExtraLight.67dbd55a.svg";